// Only Pay's beneficiaries grid imports this module; it goes when Pay leaves the repository. Pay code is not
// changed here, so the module keeps its names and takes the implementation from the shared helpers.
import { addTooltipPropsForColDefs as addTooltipPropsForColDefTypes } from '@/components/AgGrid/helpers/tooltipColDef';

export { addHeaderTooltipPropsForColDefs } from '@/components/AgGrid/helpers';

export const addTooltipPropsForColDefs = addTooltipPropsForColDefTypes(['select']);
